var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLangEng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--lang-eng",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2965_2573",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2965_2573)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 8.33333,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8.3335,
    width: 24,
    height: 8.33333,
    fill: "#4E7CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16.6665,
    width: 24,
    height: 8.33333,
    fill: "#FF5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 0H28V24H-4V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.25 0L11.95 9.05L24.1 0H28V3.1L16 12.05L28 20.95V24H24L12 15.05L0.0500002 24H-4V21L7.95 12.1L-4 3.2V0H-0.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 14.05L28 22V24L14.45 14.05H17.2ZM8 15.05L8.3 16.8L-1.3 24H-4L8 15.05ZM28 0V0.15L15.55 9.55L15.65 7.35L25.5 0H28ZM-4 0L7.95 8.8H4.95L-4 2.1V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05 0V24H16.05V0H8.05ZM-4 8V16H28V8H-4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 9.65V14.45H28V9.65H-4ZM9.65 0V24H14.45V0H9.65Z",
    fill: "#C8102E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLangEng);
export default __webpack_public_path__ + "static/media/icon--lang-eng.ca54f0b7f92dce8c48fb983de0e04550.svg";
export { ForwardRef as ReactComponent };